import axios from "axios"
import { MesesPlanificacionHEDTO } from "components/Admin/Horas Extras/Planificacion Horas Extras/TypesPlanificacionUnidades";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { KeyValuePair, ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeader, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { CreacionSolicitudHE, EstructuraOrganicaHEDTO, InformacionGeneralSolicitudHE, InformacionIngresoSolicPagoHE, JornadaLaboralSolicitadaHE, ResponseHistoriaHE, TiposHorasExtras } from "./TypesSolicitudPagoHE";
import { hadleAxiosError, hadleAxiosErrorResponse } from "helpers/handle-response";
import { EsMayorHora, EsMayorIgualHora, RestarHoras, SumarHoras } from "functions/TimeFunctions";

export function CalcularHorasSuplementariasYExtraordinarias(jornadaservidor: JornadaLaboralSolicitadaHE, timeHorasParaConsiderarSuplementaria: string, maxtimesinrecesofds: string) {
    var horasExtras: TiposHorasExtras = {
        horasSuplementarias: "",
        horasExtraordinarias: "",
        totalhoras:""
    }


    if (jornadaservidor.horaExtraHastaUsuario && jornadaservidor.horaExtraDesde) {

        var diferencia: string = RestarHoras(jornadaservidor.horaExtraDesde, jornadaservidor.horaExtraHastaUsuario);

        if (jornadaservidor.finSemanaFeriado === "S") {
            
            
            
            if (EsMayorIgualHora(diferencia, maxtimesinrecesofds)){
                const diferenciaTotal = RestarHoras("00:30",diferencia);
                
                horasExtras.horasExtraordinarias  = diferenciaTotal
            }
            else{
                horasExtras.horasExtraordinarias = diferencia
            }
        }

        else {
            const superaHorasSuplementarias: boolean = EsMayorHora(diferencia, timeHorasParaConsiderarSuplementaria)

            if (superaHorasSuplementarias) {
                horasExtras.horasSuplementarias = timeHorasParaConsiderarSuplementaria;
                //horasExtras.horasExtraordinarias = RestarHoras(timeHorasParaConsiderarSuplementaria, diferencia)
            }
            else{
                horasExtras.horasSuplementarias = diferencia
            }
        }


    }

    horasExtras.totalhoras = SumarHoras(horasExtras.horasExtraordinarias,horasExtras.horasSuplementarias)
    return horasExtras

}

export async function TieneCargoDirectivo() {
    const url = configData.SERVER_URL + "SolicitudPagoHorasExtras/ValidarAccesoSolicitud";
    const infoUsuario: UserData = authenticationService.currentUserValue;

    
    var infoResponse: ResponseRequestGeneric<boolean> = { status: -1, dataResponse: false }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        
        
        infoResponse = {
            status: respuesta.status,
            dataResponse: respuesta.data,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}

export async function ObtenerAniosSolicitudHE() {
    const url = configData.SERVER_URL + "SolicitudPagoHorasExtras/ObtenerAniosHE";
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPlanificacion: number[] = []
    var infoResponse: ResponseRequestGeneric<number[]> = { status: -1, dataResponse: informacionPlanificacion }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}

export async function ObtenerMesesSolicitudHE(anio: number) {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/ObtenerMesesPorAnio/${anio}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var informacionPlanificacion: MesesPlanificacionHEDTO[] = []
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}

export async function ObtenerUnidadesPlanificacionHE(anio: number, mes: number, identificacion:string = "0") {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/ObtenerUnidadesPlanificacionPersonabyMes/${anio}/${mes}/${identificacion}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var informacionPlanificacion: EstructuraOrganicaHEDTO[] = []
    var infoResponse: ResponseRequestGeneric<EstructuraOrganicaHEDTO[]> = { status: -1, dataResponse: informacionPlanificacion }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}

export async function ObtenerInformacionParaSolicitudHE(anio: number, mes: number, unidad: number) {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/ObtenerInformacionGeneralSolicitud/${anio}/${mes}/${unidad}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<InformacionGeneralSolicitudHE> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        const informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<InformacionGeneralSolicitudHE>(error)
        }
    }
    return infoResponse;
}

export async function GuardarBorradorSolicitudHE(solicitudHE:CreacionSolicitudHE){
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/SolicitudHorasExtras`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url,solicitudHE,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        infoResponse = {
            status: respuesta.status
        }


    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}

export async function FirmarEnviarSolicitudHE(solicitudHE:CreacionSolicitudHE){
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/FirmarEnviarSolicitudHorasExtras`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url,solicitudHE,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        infoResponse = {
            status: respuesta.status
        }


    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}

export async function VistaPreviaSolicitudHE(solicitudHE:CreacionSolicitudHE){
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/VistaPreviaSolicitudHorasExtras`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<string> = { status: -1 }
    try {
        const respuesta = await axios.post(url,solicitudHE,
            {
                headers: authHeaderWithUserData(infoUsuario),
                responseType: "blob"
            }
        )

        let urFormulario = window.URL.createObjectURL(respuesta.data);
        infoResponse = { status: respuesta.status, dataResponse: urFormulario }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
            infoResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }
    return infoResponse;
}

export async function VistaPreviaSolicitudHEIngresada(idSolicitud:number, ){
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/VistaPreviaSolicitudHorasExtras/${idSolicitud}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<string> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario),
                responseType: "blob"
            }
        )

        let urFormulario = window.URL.createObjectURL(respuesta.data);
        infoResponse = { status: respuesta.status, dataResponse: urFormulario }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
            infoResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }
    return infoResponse;
}

export async function ObtenerInformacionIngresoSolicitudPagoHE(anio:number, mes:number){

    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/InformacionIngresoSolicitud/${anio}/${mes}`;
    var infoResponse: ResponseRequestGeneric<InformacionIngresoSolicPagoHE> = { status: -1 }

    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeader(),
            }
        )

        
        infoResponse = { status: respuesta.status, dataResponse: respuesta.data }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<InformacionIngresoSolicPagoHE>(error)
        }
    }
    return infoResponse;
}



export async function ObtenerHistorialSolicitudesHE(){
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/HistorialSolicitudes`;
    const infoUsuario: UserData = authenticationService.currentUserValue;


    var infoResponse: ResponseRequestGeneric<ResponseHistoriaHE> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario),
            }   
        )

        infoResponse = { 
            status: respuesta.status, 
            dataResponse: respuesta.data 
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<ResponseHistoriaHE>(error)
        }
    }
    return infoResponse;
}

